import type { TimeRange } from '@/mocks/superAdminAnalytics';

interface TimeRangeSelectorProps {
  active: TimeRange;
  onChange: (range: TimeRange) => void;
}

const options: { key: TimeRange; label: string; icon: string }[] = [
  { key: 'diario', label: 'Diario', icon: 'ri-calendar-line' },
  { key: 'semanal', label: 'Semanal', icon: 'ri-calendar-check-line' },
  { key: 'mensual', label: 'Mensual', icon: 'ri-calendar-2-line' },
  { key: 'anual', label: 'Anual', icon: 'ri-calendar-todo-line' },
];

export default function TimeRangeSelector({ active, onChange }: TimeRangeSelectorProps) {
  return (
    <div className="flex items-center gap-1 px-1 py-1 bg-background-100 rounded-full">
      {options.map((opt) => (
        <button
          key={opt.key}
          onClick={() => onChange(opt.key)}
          className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-[10px] font-medium transition-all cursor-pointer whitespace-nowrap ${
            active === opt.key
              ? 'bg-foreground-950 text-background-50 shadow-sm'
              : 'text-foreground-500 hover:text-foreground-700 hover:bg-background-200'
          }`}
        >
          <i className={`${opt.icon} text-[10px]`}></i>
          {opt.label}
        </button>
      ))}
    </div>
  );
}